<template>
  <section class="ugc-confirmation-controls">
    <button
      class="ugc-confirmation-controls-item"
      :aria-label="translations.ugcConfirmationControlCancel"
      :disabled="buttonsDisabled"
      @click="dispatchOnCancel"
    >
      <span
        v-if="!$store.state.utils.configuration.enableNewUgcModal"
        class="icon icon-close"></span>
      <customs-svg-icon
        v-else
        :src="`${ customsAssets }/svg/customizer/icon-close.svg`"
      ></customs-svg-icon>
      {{ translations.ugcConfirmationControlCancel }}
    </button>
    <button
      class="ugc-confirmation-controls-item"
      :aria-label="translations.ugcConfirmationControlDone"
      :disabled="buttonsDisabled"
      @click="dispatchOnDone"
    >
      <span
      v-if="!$store.state.utils.configuration.enableNewUgcModal"
      class="icon icon-checkmark"></span>
      <customs-svg-icon
        v-else
        :src="`${ customsAssets }/svg/customizer/icon-checkmark.svg`"
      ></customs-svg-icon>
      {{ translations.ugcConfirmationControlDone }}
    </button>
  </section>
</template>

<script>
import customsSvgIcon from '@/components/Globals/SvgIcon';

export default {
  name: "UgcToolsConfirmationControls",
  components: {
    customsSvgIcon,
  },
  props: {
    /**
     * Function that gets executed when clicking the cancel button
     */
    onCancel: {
      type: Function,
      default: null
    },
    /**
     * Function that gets executed when clicking the done button
     */
    onDone: {
      type: Function,
      default: null
    }
  },
  methods: {
    dispatchOnCancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.$eventBus.$emit("confirmation-controls:cancel");
    },
    dispatchOnDone() {
      if (this.onDone) {
        this.onDone();
      }
      this.$eventBus.$emit("confirmation-controls:done");
    },
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    buttonsDisabled() {
      if (this.$store.getters["utils/isGCC"]) {
        return false;
      }
      return this.$store.state.ugc.stateManager.isLoading;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    }
  }
};
</script>
